<template>
  <div class="container">
    <div class="signin__card">
      <img
        v-show="shouldShowCompanyLogo() && !isAnonimous"
        :src="logo"
        alt="Company Logo"
        class="signin__card--logo"
      />
      <h2 v-show="isAnonimous">Empresa anônima</h2>
      <h4 class="signin__card--title">Bem vindo, faça login com a sua conta</h4>
      <button
        class="signin__card--whatsapp"
        v-if="optimizelyIsEnabled()"
        @click="() => (popupActivity = !popupActivity)"
      >
        <div class="mr-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            width="18px"
            height="18px"
            viewBox="0 0 30.667 30.667"
            style="enable-background: new 0 0 30.667 30.667"
            xml:space="preserve"
            class=""
          >
            <g>
              <g>
                <path
                  d="M30.667,14.939c0,8.25-6.74,14.938-15.056,14.938c-2.639,0-5.118-0.675-7.276-1.857L0,30.667l2.717-8.017   c-1.37-2.25-2.159-4.892-2.159-7.712C0.559,6.688,7.297,0,15.613,0C23.928,0.002,30.667,6.689,30.667,14.939z M15.61,2.382   c-6.979,0-12.656,5.634-12.656,12.56c0,2.748,0.896,5.292,2.411,7.362l-1.58,4.663l4.862-1.545c2,1.312,4.393,2.076,6.963,2.076   c6.979,0,12.658-5.633,12.658-12.559C28.27,8.016,22.59,2.382,15.61,2.382z M23.214,18.38c-0.094-0.151-0.34-0.243-0.708-0.427   c-0.367-0.184-2.184-1.069-2.521-1.189c-0.34-0.123-0.586-0.185-0.832,0.182c-0.243,0.367-0.951,1.191-1.168,1.437   c-0.215,0.245-0.43,0.276-0.799,0.095c-0.369-0.186-1.559-0.57-2.969-1.817c-1.097-0.972-1.838-2.169-2.052-2.536   c-0.217-0.366-0.022-0.564,0.161-0.746c0.165-0.165,0.369-0.428,0.554-0.643c0.185-0.213,0.246-0.364,0.369-0.609   c0.121-0.245,0.06-0.458-0.031-0.643c-0.092-0.184-0.829-1.984-1.138-2.717c-0.307-0.732-0.614-0.611-0.83-0.611   c-0.215,0-0.461-0.03-0.707-0.03S9.897,8.215,9.56,8.582s-1.291,1.252-1.291,3.054c0,1.804,1.321,3.543,1.506,3.787   c0.186,0.243,2.554,4.062,6.305,5.528c3.753,1.465,3.753,0.976,4.429,0.914c0.678-0.062,2.184-0.885,2.49-1.739   C23.307,19.268,23.307,18.533,23.214,18.38z"
                  data-original="#000000"
                  class="active-path"
                  data-old_color="#000000"
                  fill="#FFFFFF"
                />
              </g>
            </g>
          </svg>
        </div>
        Cadastre-se com WhatsApp
      </button>
      <vs-divider v-if="optimizelyIsEnabled()" position="center"> ou </vs-divider>
      <ValidationObserver
        ref="observer"
        tag="form"
        v-slot="{ invalid }"
        @submit.prevent="handleSignIn()"
      >
        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
          <vs-input
            class="signin__card--input"
            icon="email"
            type="email"
            v-model="email"
            label-placeholder="Email"
            placeholder="Insira o email"
            :danger="errors.length > 0"
            :danger-text="errors[0]"
          />
        </ValidationProvider>
        <ValidationProvider name="senha" rules="required" v-slot="{ errors }">
          <vs-input
            class="signin__card--input"
            icon="https"
            type="password"
            v-model="password"
            label-placeholder="Senha"
            placeholder="Insira a senha"
            :danger="errors.length > 0"
            :danger-text="errors[0]"
          />
        </ValidationProvider>
        <span class="text-danger text-sm">
            {{ api_error }}
          </span>
        <div class="signin__card--forgot-password">
          <router-link to="forgot-password"> Esqueceu a sua senha? </router-link>
        </div>
        <button
          type="submit"
          :disabled="invalid"
          :style="{ opacity: invalid ? 0.3 : 1 }"
          class="signin__card--submit bg-primary"
        >
          Iniciar candidatura
        </button>
      </ValidationObserver>
      <p class="signin__card--account">
        Não tem uma conta ainda?
        <vs-button
          type="flat"
          class="signin__card--account-link p-0"
          @click="handleRedirect"
        >
          Criar uma conta
        </vs-button>
      </p>
      <div class="mt-6">
        <hr>
      </div>
      <p class="signin__card--forgot-password mt-2">
        Esqueceu o email?
        <vs-button
          type="flat"
          class="signin__card--forgot-password p-0"
          @click="handleRedirectCpf"
        >
          Faça login com CPF
        </vs-button>
      </p>
    </div>
    <vs-popup title="" :active.sync="popupActivity">
      <div class="conditions__container">
        <img
          src="@/assets/images/logo/logo.png"
          alt="Recrutei logo"
          class="conditions__logo"
        />
        <p class="conditions__title">
          Atualizamos nossos Termos de uso e Política de privacidade
        </p>
        <p class="conditions__description">
          Entendemos que você está de acordo com os novos termos de privacidade assim que
          clicar em concordo com os novos termos e continuar utilizando a Experiência de
          Talentos. Para consultar os termos, é só clicar nos links:
          <a
            href="https://recrutei.com.br/termos-de-uso"
            target="_blank"
            class="conditions__link"
            >Termos e condições de uso</a
          >
          e
          <a
            href="https://recrutei.com.br/privacidade-e-seguranca"
            target="_blank"
            class="conditions__link"
            >Política de privacidade</a
          >.
        </p>
        <vs-divider position="center"> </vs-divider>
        <ul>
          <li class="checkbox-wrapper">
            <vs-checkbox v-model="policy_and_privacy">
              <span>Concordo com as </span>
            </vs-checkbox>
            <a href="https://recrutei.com.br/privacidade-e-seguranca" target="blank"
              >Políticas de Privacidade</a
            >
            <span v-if="policy_error" class="checkbox-warning"
              >Clique no quadro para declarar que está de acordo com a política de
              privacidade</span
            >
          </li>
          <li class="checkbox-wrapper">
            <vs-checkbox v-model="conditions_terms">
              <span>Concordo com as </span>
            </vs-checkbox>
            <a href="https://recrutei.com.br/termos-de-uso" target="blank"
              >Termos de uso</a
            >
            <span v-if="condition_error" class="checkbox-warning"
              >Clique no quadro para informar que está de acordo com os termos de
              uso</span
            >
          </li>
        </ul>
        <vs-button @click="handleWhatsApp">Continuar com cadastro</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { keys, get } from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import * as Sentry from "@sentry/vue";
import { identifyTalent, trackNewApplication, trackEvent } from "@/services/posthog";

export default {
  name: "sign-in-form",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    isLoading: true,
    condition_error: false,
    conditions_terms: false,
    policy_error: false,
    policy_and_privacy: false,
    popupActivity: false,
    email: "",
    password: "",
    api_error: "",
  }),
  methods: {
    ...mapActions("step", ["updateCurrentStep"]),
    handleRedirect() {
      const { query, params } = this.$router.history.current;

      this.$router.push({
        name: "signup",
        params,
        query,
      });
    },
    handleRedirectCpf() {
      const { query, params } = this.$router.history.current;

      this.$router.push({
        name: "signin-cpf",
        params,
        query,
      });
    },
    handleWhatsApp() {
      if (this.policy_and_privacy && this.conditions_terms) {
        this.popupActivity = false;
        const { company_label, vacancy_id } = this.$router.history.current.params;
        const { utm_source, clickid, utm_campaign, utm_medium } = this.$router.history.current.query;
        window.open(
          `https://wa.me/553493389648?text=Ol%C3%A1,%20quero%20me%20candidatar%20em:%20https://jobs.recrutei.com.br/${company_label}/vacancy/${vacancy_id}?utm_source=${utm_source}%26utm_medium=${utm_medium}%26utm_campaign=${utm_campaign}`,
          "_blank"
        );
      } else {
        if (!this.policy_and_privacy) this.policy_error = true;
        if (!this.conditions_terms) this.condition_error = true;
      }
      return;
    },
    shouldShowCompanyLogo() {
      return keys(this.company).length > 0;
    },
    optimizelyIsEnabled() {
      if (!this.company) return false;

      return (
        this.company.has_bot && this.$router.history.current.params.vacancy_id !== undefined
      );
    },
    async handleSignIn() {
      const isValid = await this.$refs.observer.validate();

      const { utm_source, clickid, utm_campaign, utm_medium } = this.$router.history.current.query;

      sessionStorage.setItem("utm_source", utm_source);

      if (!isValid) return;

      this.$vs.loading({
        text: "Carregando...",
      });

      const params = this.$router.history.current.params;

      let uri = "";

      if (params.company_label === "anonima") {
        uri = `/api/v2/talents/anonimo/login/${params.vacancy_id}`;
      } else {
        uri = params.vacancy_id
          ? `/api/v1/talent/${params.company_label}/login/${params.vacancy_id}`
          : `/api/v1/talent/${params.company_label}/login`;
      }

      this.$http
        .post(uri, 
        { 
          email: this.email, 
          password: this.password,
          channel: (utm_source !== "" || utm_source !== undefined) ? utm_source : null,
          clickid: (clickid !== "" || clickid !== undefined) ? clickid : null,
          utm_campaign: (utm_campaign !== "" || utm_campaign !== undefined) ? utm_campaign : null,
          utm_medium: (utm_medium !== "" || utm_medium !== undefined) ? utm_medium : null
        })
        .then(async (response) => {
          this.$vs.loading.close();

          // Verifica se a empresa está inativa
          if (response.data && response.data.company && response.data.company.active === 0) {
            this.api_error = "Esta empresa não está mais ativa na Recrutei.";
            return;
          }

          if (params.company_label === "anonima") {
            // TODO: Retornar o application_id na resposta
            const {
              token,
              data: { talent },
            } = response.data;

            this.$store.dispatch("auth/addToken", { token });
            this.$store.dispatch("diversity/addUser", { user: talent.user });
            this.$store.dispatch("diversity/addDiversity", talent);

            localStorage.setItem("userToken", token);

            Sentry.setUser({
              username: talent.user.name,
              email: talent.user.email,
            });

            // PostHog identify (anonima) - identificador por email
            identifyTalent(talent.user && talent.user.email, {
              email: talent.user && talent.user.email,
              name: talent.user && talent.user.name,
              last_company_label: params.company_label,
            });
          } else {
            const { company, token, user, talent, application_id } = response.data;

            this.$store.dispatch("diversity/addDiversity", talent);
            this.$store.dispatch("auth/addUser", {
              user: {
                ...user,
                talent
              }
            });
            this.$store.dispatch("auth/addToken", { token });
            this.$store.dispatch("company/addId", { company });

            localStorage.setItem("userToken", token);
            sessionStorage.setItem("@recrutei:talent:application_id", application_id);

            Sentry.setUser({ username: user.name, email: user.email });

            // PostHog identify - identificador por email
            identifyTalent(user && user.email, {
              email: user && user.email,
              name: user && user.name,
              last_company_label: params.company_label || (company && company.label),
            });

            // Track new_application (signup/signin flow with application creation)
            if (application_id) {
              const { vacancy_id, company_label } = this.$router.history.current.params;
              trackNewApplication({
                vacancy_id,
                company_id: company && company.id,
                company_name: company && company.name,
                company_label: company_label || (company && company.label),
                channel: (utm_source && utm_source !== "") ? utm_source : undefined,
              });
            }
            // Track simple login (sem candidatura)
            const { vacancy_id: vIdSimple } = this.$router.history.current.params;
            if (!vIdSimple || vIdSimple === undefined) {
              trackEvent("logged_account", {
                channel: (utm_source && utm_source !== "") ? utm_source : undefined,
              });
            }
          }

          const { vacancy_id, company_label } = this.$router.history.current.params;

          this.$router.push({
            name: vacancy_id ? "step-basic-info" : "dashboard-vacancy",
            params: {
              vacancy_id,
              company_label,
            },
          });

          await this.updateCurrentStep({ order: 0 });
        })
        .catch((error) => {
          this.$vs.loading.close();

          const { data, status } = error.response;

          if (status === 307 && data !== undefined && data.hasOwnProperty("message"))
            this.api_error = data.message;

          if (status === 404) {
            this.api_error = "Vaga não encontrada. Verifique a url de candidatura e tente novamente.";
          }

          if (status === 422) this.api_error = data;

          if (status === 422 && data !== undefined && data.hasOwnProperty("errors")){
            if(data.errors[0].errors === "The selected email is invalid.")
              this.api_error = "O email selecionado não existe.";  
            else
              this.api_error = data.errors[0].errors;
          }

          if (status === 422 && data !== undefined && !data.hasOwnProperty("errors")){
            this.api_error = data.message;
          }

        });
    },
  },
  computed: {
    ...mapState("company", ["company"]),

    logo() {
      const { company } = this.$store.state.company;
      return company.logo_url;
    },

    isAnonimous() {
      const label = get(this.$router, "history.current.params.company_label", null);
      return label === "anonima";
    },
  },
  watch: {
    conditions_terms(value) {
      if (value) this.condition_error = false;
    },
    policy_and_privacy(value) {
      if (value) this.policy_error = false;
    },
  },
  created() {
    if (!this.company) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}
.signin__card {
  display: flex;
  flex-direction: column;
  padding: 16px;
  max-width: 360px;
  background: #fff;

  h2 {
    text-align: center;
  }

  &--logo {
    max-width: 130px;
    max-height: 150px;
    margin: 0 auto;
    margin-bottom: 05px;
    margin-top: 10px;
    object-fit: contain;
  }

  &--whatsapp {
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    text-decoration: none;
    color: #fff !important;
    cursor: pointer;
    font-weight: 500;
    background-color: #25d366;
    width: 100%;
    padding: 8px;
    margin: 10px 0;
  }

  &--title {
    font-size: 18px;
    margin: 20px 0;
  }

  &--input {
    width: 100%;
    margin: 20px 0;
  }

  &--forgot-password {
    margin: 15px 0;

    a {
      font-size: 12px;
    }
  }

  &--submit {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.85rem 2.5rem;
    color: white;
    font-size: 16px;
    font-weight: 200;
    border: 0px;
    border-radius: 5px;

    margin-bottom: 20px;
    transition: color 0.5s;

    &:hover {
      color: #fcfcfc;
      cursor: pointer;
    }
  }

  &--account {
    font-size: 14px;

    a {
      font-weight: 500;
    }
  }
}

.conditions__container {
  display: flex;
  flex-direction: column;
  padding: 10px;

  hr {
    border-color: red;
  }
}

.conditions__logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin: 0 auto;
}

.conditions__title {
  text-align: center;
  margin-bottom: 20px;
}

.conditions__description {
  text-align: center;
  letter-spacing: 0.1px;
}

.checkbox-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 10px;

  span {
    font-size: 12px;
  }

  a {
    font-size: 12px;
  }
}

.checkbox-wrapper:nth-of-type(2) {
  margin-bottom: 30px;
}

.checkbox-warning {
  font-size: 9.1px !important;
  color: #ea5455;
  margin: 10px 0;
}
</style>
